import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SALES_ORDER_TYPE_CODES } from 'src/app/constants/so-type-codes';
import { FormService } from 'src/app/services/form.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { CycleInventoryReportService } from '../cycle-inventory-report.service';
import { CycleComparisonItem } from '../interfaces/cycle-comparison-item.interface';
import { CycleInventoryReportComparison } from '../interfaces/cycle-inventory-report-comparison.interface';
import { CycleInventoryReportPayload } from '../interfaces/cycle-inventory-report-payload.interface';
import { ModelCartHead2Department } from '../interfaces/model-cart-head-2-department.interface';
import { ModelCartHead2StoreRef } from '../interfaces/model-cart-head-2-store-ref.interface';
import { TransferRecommendation } from '../interfaces/transfer-recommendation.interface';

@Component({
  selector: 'app-cycle-inventory-utility-report',
  templateUrl: './cycle-inventory-utility-report.component.html',
  styleUrls: ['./cycle-inventory-utility-report.component.scss']
})
export class CycleInventoryUtilityReportComponent implements OnInit {
  
  cart: any;
  cartId;
  date: any;
  time: any;
  displayedColumns: Array<string> = ['vendor', 'model', 'category', 'barcode', 'location', 'status', 'scanned', 'inv', 'messages'];
  dataSource: Array<CycleComparisonItem>;
  loading: boolean = true;
  payload: CycleInventoryReportPayload;
  reportComparison: CycleInventoryReportComparison;
  salesOrderCodes: any = SALES_ORDER_TYPE_CODES;

  constructor(
    private cycleInventoryReportService: CycleInventoryReportService,
    private formSvc: FormService,
    private router: Router,
    public utilsSvc: UtilitiesService
  )
  {
    // Retrieve payload data from state data, which is passed through navigation.
    const state = this.router.getCurrentNavigation().extras.state;
    this.payload = state.payload;
    this.cart = state.cart;
    this.cartId = state.cartId;
  }

  ngOnInit(): void {
    this.getReport();
  }  
  
  /**
  * Get excluded departments in comma separated list form
  */
 getExcludedDepartments(): string {
   if (this.cart && this.cart.ModelCartHead2Departments.length > 0) {
     const departments: Array<ModelCartHead2Department> = this.cart.ModelCartHead2Departments;
     return this.utilsSvc.arrayToCSV(departments, 'DepartmentCode');
   }
   else if (this.reportComparison?.ModelCartHead2Departments.length === 0) {
     return 'None';
   }
 }

 getMessage(comparisonItem: CycleComparisonItem): string {

    const scannedQty = comparisonItem.ScannedQty;
    const invQty = comparisonItem.InvQty;
    let recommendMsg: string = '';
    let location: string = '';
    let reservedMsg: string = '';

    let finalMsg: string = '';

    if(comparisonItem.OutOfStoreRange){
      finalMsg = "Location outside of Store Range"
    }
    else if(comparisonItem.ExcludedDepartment){
      finalMsg = "Model in Excluded Department"
    }
    else{
      // if there is a discrepancy
      if (comparisonItem.AdjustmentAmount > 0) {
      
        // recommend Action for inventory
        recommendMsg = `Rec Action: ${comparisonItem.AdjustmentMethod} ${comparisonItem.AdjustmentAmount}`;
      
        if ((scannedQty !== invQty) && !!comparisonItem.SoHeadCode) {
          if (comparisonItem.SoTypeCode === 1){
            reservedMsg = `- Sales Order ${comparisonItem.SoHeadCode}`
          }
          else {
            reservedMsg = `- ${SALES_ORDER_TYPE_CODES[comparisonItem.SoTypeCode - 1].label} ${comparisonItem.SoHeadCode}`
          }
        }
        if ((scannedQty !== invQty) && !!comparisonItem.TranHeadCode) {
          reservedMsg = `- Pending Xfer ${comparisonItem.TranHeadCode}`
        }
      
      // specify location
      location = `, Location: ${comparisonItem.LocationRefCode}`
      }

      finalMsg = `${recommendMsg} ${location} ${reservedMsg}`;
    }
    
    return finalMsg;
 }

  /**
   * Get Report
   */
  getReport() {
    // Set report creation time
    this.date = new Date();
    this.time = new Date().toLocaleTimeString();

    const processedPayload: CycleInventoryReportPayload = this.formSvc.getObjectEmptyToNull(this.payload);
    this.cycleInventoryReportService.create(this.cartId, processedPayload)
      .subscribe((reportComparison: CycleInventoryReportComparison) => {
        this.reportComparison = reportComparison;
        this.dataSource = reportComparison.Comparisons;
        this.loading = false;
      });
  }

  /**
   * Get Stores in comma separated list form
   */
  getStores(): string {
    if (this.reportComparison && this.reportComparison.ModelCartHead2StoreRefs.length > 0) {
      const stores: Array<ModelCartHead2StoreRef> = this.reportComparison.ModelCartHead2StoreRefs;
      return this.utilsSvc.arrayToCSV(stores, 'StoreRefCode');
    }
    else if (this.reportComparison?.ModelCartHead2StoreRefs.length === 0) {
      return 'All';
    }
  }

  getTransferRecommendationMsg(transRec: TransferRecommendation): string {
    //const locationId = item.LocationRefId;

    let msg = '';

    
    if (transRec.LostAmount && transRec.LostAmount > 0){
      msg = `Transfer ${transRec.LostAmount} to Status`
    }
    else if (!transRec.TransferFromLocationRefCode) {
      msg = `Trnsf Out: ${transRec.TransferToAmount} - To Loc: ${transRec.TransferToLocationRefCode}`;
    }
    else if (!transRec.TransferToLocationRefCode) {
      
      msg = `Trnsf In: ${transRec.TransferFromAmount} - From Loc: ${transRec.TransferFromLocationRefCode}`;
    }

    return msg;
  }

  printReport(): void {
    window.print();
  }
}
